import styled from "styled-components";
import { HorizontalAlignment } from "../../../components/types";
import { Device } from "../../../components/device";
import { A } from "../GlobalStyle/Utilities";

//Text wrapper: horizontal text alignment.

//Usage:
/*
<Text horizontalAlign="center">
    --Content here--
</Text>
*/

interface TextProps
{
    horizontalAlign?: HorizontalAlignment;
}

const RichText = styled.div<TextProps>`
    text-align: ${props =>
        (props.horizontalAlign === "left") ? "left" :
            (props.horizontalAlign === "center") ? "center" :
                (props.horizontalAlign === "right") ? "right" :
                    "inherit"};
    ${Device.tablet} {
        margin-bottom: 0;
    }

    ul {
        list-style: none !important;
    }
    li {
        margin-bottom: .5rem;
        position: relative;
        padding-left: 1.5rem;
        &::before {
            background-color: currentColor;
            border-radius: 0.2rem;
            content: '';
            display: inline-block;
            height: 0.4rem;
            width: 0.4rem;
            position: absolute;
            top: .5rem;
            left: 0;
        }
    }
    a:not(.btn) {
        ${A}
    }
    > h1, h2{
        &:first-child{
            padding-top: 0.75rem;
        }        
    }
    h3{
        &:first-child{
            padding-top: 0.5rem;
        }
    }
    h4, h5{
        &:first-child{
            padding-top: 0.25rem;
        }
    }
`;

export default RichText;